/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Company,
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateCompanyRequest
 */
export interface CreateCompanyRequest {
    /**
     * 
     * @type {Company}
     * @memberof CreateCompanyRequest
     */
    company: Company;
}

export function CreateCompanyRequestFromJSON(json: any): CreateCompanyRequest {
    return CreateCompanyRequestFromJSONTyped(json, false);
}

export function CreateCompanyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompanyRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'company': CompanyFromJSON(json['company']),
    };
}

export function CreateCompanyRequestToJSON(value?: CreateCompanyRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company': CompanyToJSON(value.company),
    };
}


